import { QueryKey, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useMovieActivityContext } from "src/components/film/filmwebid/MovieActivityContext";
import { emptyMovieActivity, IMovieActivity, IUserDataForMovie } from "src/lib/filmwebid/IMovieActivity";
import { buildUserApiQueryKey, UserApiQueryKey } from "src/lib/filmwebid/useUserApiQuery";

export function useMovieActivityOptimisticUpdater(queryKey: UserApiQueryKey) {
    const queryClient = useQueryClient();
    const { optimisticUpdater } = useMovieActivityContext();

    return useCallback(async (updater: (old: IMovieActivity) => IMovieActivity) => {
        // Snapshot the previous value
        const previousData = queryClient.getQueryData<IMovieActivity>(queryKey)

        // Cancel any outgoing refetches
        // (so they don't overwrite our optimistic update)
        await queryClient.cancelQueries({ queryKey })

        optimisticUpdater((old) => updater(old ?? emptyMovieActivity));

        // Return a context object with the snapshotted value
        return { previousData }
    }, [queryKey, queryClient, optimisticUpdater]);
}
